import { createFileRoute } from '@tanstack/react-router';
import Memberships from 'src/pages/Organization/Players/Memberships';

export const Route = createFileRoute(
  '/$organizationSlug/players/$playerId/memberships',
)({
  component: Memberships,
});
